import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Form, Grid, Button, Input, Checkbox, Icon } from 'semantic-ui-react';
import { Commons } from 'components';

import * as cm_action from 'actions/commons';
import * as sik_action from 'actions/sikdae';

const propTypes = {};

const defaultProps = {};

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sikdaeGroupVal: 0
    };
  }

  componentWillMount() {
    this.sikdaeGroupSel();
    this.divisionSel();
  }

  //식대 그룹 조회
  sikdaeGroupSel = async () => {
    const { cmAPI } = this.props;

    try {
      await cmAPI.sikdaeGroupList();
    } catch (e) {
      console.log('###### sikdaeGroup : ', e);
    } finally {
    }
  };
  //식대그룹 search
  sikdaeGroupSearch = async () => {
    const { groupIdx } = this.props;

    if (groupIdx.value && groupIdx.value !== 0) {
      const { cmAPI } = this.props;

      try {
        //식대정책 조회
        await cmAPI.sikdaePolicyList(groupIdx.value);
      } catch (e) {
        console.log('##### sikdaePolicyList error : ', e);
      }

      await this.setState({ sikdaeGroupVal: groupIdx });
    } else {
      await this.setState({
        sikdaeGroupVal: { value: null }
      });
    }
  };

  //부서 search
  divisionSel = async () => {
    try {
      const { cmAPI } = this.props;

      await cmAPI.divisionList();
    } catch (e) {
      console.log('###### divisionSearch : ', e);
    } finally {
    }
  };

  searchClick = (type) => {
    const { modalAction, storeModalAction, sort } = this.props;

    if (type === 'staff') {
      if (sort.user) {
        modalAction('open', true);
      }
    } else {
      if (sort.store) {
        storeModalAction('open', true);
      }
    }
  };

  delete = (type) => {
    const { fn } = this.props;

    if (type === 'staff') {
      fn.choiceStaff('', '');
    } else if (type === 'store') {
      fn.choiceStore('', '');
    }
  };

  style = (e, type) => {
    if (type === 'over') {
      e.target.style.cursor = 'pointer';
      e.target.style.background = '#e5e5e5';
      e.target.style.color = 'white';
    } else {
      e.target.style.background = 'white';
      e.target.style.color = 'black';
    }
  };

  render() {
    const { sikdaeGroupVal } = this.state;
    const { groupIdx, sikdaePolicy, staff, storeinfo, submitForm, fn, sort } = this.props;

    return (
      <Form className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group>
                <Commons.DateType isSum={true} />
                <Commons.DateForm />
              </Form.Group>
            </Grid.Column>
            <Grid.Column width={2} className="right">
              <Button color="black" inverted content="조회" onClick={submitForm} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group inline style={{ margin: 0 }}>
                <Checkbox onChange={(e, data) => fn.caseCheckboxAction(e, data, 'user')} />
                <Input
                  className="bind"
                  value={staff.name}
                  labelPosition="right"
                  disabled={!sort.user}
                  action={{
                    icon: 'search',
                    type: 'button',
                    onClick: (e) => this.searchClick('staff')
                  }}
                  onClick={(e) => this.searchClick('staff')}
                  label={{
                    basic: true,
                    content: 'x',
                    onClick: (e) => this.delete('staff'),
                    onMouseOver: (e) => this.style(e, 'over'),
                    onMouseOut: (e) => this.style(e, 'out')
                  }}
                  placeholder="사용자 전체"
                />

                <Checkbox onChange={(e, data) => fn.caseCheckboxAction(e, data, 'store')} />
                <Input
                  className="bind"
                  value={storeinfo.name}
                  labelPosition="right"
                  disabled={!sort.store}
                  action={{
                    icon: 'search',
                    type: 'button',
                    onClick: (e) => this.searchClick('store')
                  }}
                  onClick={(e) => this.searchClick('store')}
                  label={{
                    basic: true,
                    content: 'x',
                    onClick: (e) => this.delete('store'),
                    onMouseOver: (e) => this.style(e, 'over'),
                    onMouseOut: (e) => this.style(e, 'out')
                  }}
                  placeholder="제휴식당 전체"
                />
                <Checkbox onChange={(e, data) => fn.caseCheckboxAction(e, data, 'group')} />
                <Commons.SikdaeGroup sikdaeGroupSearch={this.sikdaeGroupSearch} isDim={!sort.group} />

                <Checkbox
                  disabled={!sort.group}
                  checked={sort.policy}
                  onChange={(e, data) => fn.caseCheckboxAction(e, data, 'policy')}
                />
                <Commons.SikdaePolicy
                  sikdaePolicy={sikdaeGroupVal.value ? sikdaePolicy : null}
                  sikdaeGroupVal={sikdaeGroupVal}
                  isDim={!sort.policy}
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group inline style={{ margin: '1em 0 0 0' }}>
                <Checkbox
                  style={{ marginBottom: 16 }}
                  onChange={(e, data) => fn.caseCheckboxAction(e, data, 'division')}
                />
                <Commons.Division style={{ marginBottom: 8 }} isDim={!sort.division} />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

SearchBox.propTypes = propTypes;
SearchBox.defaultProps = defaultProps;

SearchBox = connect(
  (state) => ({
    groupIdx: state.commons.group,
    sikdaePolicy: state.commons.sikdaePolicy
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupList: cm_action.SikdaeGroupList,
        sikdaePolicyList: cm_action.SikdaePolicyList,
        divisionList: cm_action.DivisionList
      },
      dispatch
    )
  })
)(SearchBox);

export default SearchBox;
